module.exports = __webpack_public_path__ + "img/Red tea SIM 2手机@2x.72d86b5b.png";